<template>
	<home-tile
		:button-title="'View Transactions'"
		@click="showCard"
		v-if="failedTransactions && !failedPayout && monthDiff(cardExp) > 2"
		color="danger"
		v-bind:style="{ paddingTop: '50px' }"
	>
		<h3 class="tile-header" style="margintop: -35px; margin-bottom: 10px">
			You have {{ failedTransactions }} failed
			{{ failedTransactions > 1 ? 'donations' : 'donation' }}
		</h3>
		<span class="tile-text-small">View transactions to reprocess</span>
	</home-tile>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import { monthDiff } from '../../utilities'
import HomeTile from './HomeTile'

export default {
	name: 'roundups-error-tile-1',
	components: { HomeTile },
	computed: {
		...mapGetters(['failedTransactions', 'failedPayout']),
		...mapState({
			cardExp: ({ me }) => me.current.card_exp
		})
	},
	methods: {
		...mapActions(['getHome']),
		showCard() {
			this.navigate({ name: 'roundups' }, 'forward')
		},
		monthDiff
	},
	mounted() {}
}
</script>

<style lang="scss">
.tile-header {
	color: #fff;
}
</style>
